export enum EQuestionLabel {
  Company = "Company name",
  Country = "Region/country",
  IsAgency = "Are you an agency",
  Name = "Full Name",
  Email = "Email",
  Industry = "Industry",
  PhoneNumber = "PhoneNumber",
  Budget = "Monthly advertising budget",
  Website = "Company Website",
  CompetitorPlatformUsed = "Do you advertise on any of the following digital platforms?",
  MarketingDestination = "What is your marketing destination?",
  MarketingObjective = "What are your marketing goals?",
  BusinessRole = "What is your business role?",
  Title = "Title",
  ConsiderTiktokAds = "Would you consider doing paid advertisement on TikTok in the next 90 days?"
}
export enum EQuestionKey {
  Company = "company",
  Country = "country",
  IsAgency = "is_agency",
  Name = "name",
  Email = "email",
  Industry = "industry",
  PhoneNumber = "phonenumber",
  Budget = "budget",
  Website = "website",
  CompetitorPlatformUsed = "competitor_platform_used",
  MarketingDestination = "marketing_destination",
  MarketingObjective = "marketing_objective",
  BusinessRole = "business_role",
  Title = "title",
  ConsiderTiktokAds = "consider_tiktok_ads"
}

// 线索表单类型
export const QuestionsMap = {
  [EQuestionLabel.Company]: EQuestionKey.Company,
  [EQuestionLabel.Country]: EQuestionKey.Country,
  [EQuestionLabel.IsAgency]: EQuestionKey.IsAgency,
  [EQuestionLabel.Name]: EQuestionKey.Name,
  [EQuestionLabel.Email]: EQuestionKey.Email,
  [EQuestionLabel.Industry]: EQuestionKey.Industry,
  [EQuestionLabel.PhoneNumber]: EQuestionKey.PhoneNumber,
  [EQuestionLabel.Budget]: EQuestionKey.Budget,
  [EQuestionLabel.Website]: EQuestionKey.Website,
  [EQuestionLabel.CompetitorPlatformUsed]: EQuestionKey.CompetitorPlatformUsed,
  [EQuestionLabel.MarketingDestination]: EQuestionKey.MarketingDestination,
  [EQuestionLabel.MarketingObjective]: EQuestionKey.MarketingObjective,
  [EQuestionLabel.BusinessRole]: EQuestionKey.BusinessRole,
  [EQuestionLabel.Title]: EQuestionKey.Title,
  [EQuestionLabel.ConsiderTiktokAds]: EQuestionKey.ConsiderTiktokAds
};
export enum IsNeedPhoneNumber {
  NEED = 1,
  DON_NEED = 0
}

export interface ILeadFormConf {
  creator: string;
  id: number;
  isNeedPhoneNumber: IsNeedPhoneNumber;
  leadOwner: string;
  questions: EQuestionLabel[];
  redirectLink: string;
  sign: string;
}

export const requireQuestions = [
  "confirm",
  EQuestionKey.Email,
  EQuestionKey.Country
];

// 自定义线索表单的问题顺序
export const customFormItemOrder: (EQuestionKey | string)[] = [
  EQuestionKey.Name,
  EQuestionKey.Email,
  EQuestionKey.PhoneNumber,
  EQuestionKey.Country,
  EQuestionKey.Country,
  EQuestionKey.Industry,
  EQuestionKey.IsAgency,
  EQuestionKey.Budget,
  EQuestionKey.Website,
  EQuestionKey.CompetitorPlatformUsed,
  EQuestionKey.ConsiderTiktokAds,
  "confirm"
];

export interface ILoginInfo {
  id: string;
  email: string;
  name: string;
  mobile: string;
  phonenumber: string;
}
/* ----- 注册表单类型 ----- */

export enum FormState {
  none,
  register,
  leaveInfo,
  createAccount,
}

export const FormKeyMap = {
  [FormState.none]: "register",
  [FormState.register]: "register",
  [FormState.leaveInfo]: "leaveInfo",
  [FormState.createAccount]: "createAccount",
}

export const FormTitleMap = {
  [FormState.none]: "form_register_title",
  [FormState.register]: "form_register_title",
  [FormState.leaveInfo]: "form_leaveinfo_title",
  [FormState.createAccount]: "form_register_adv_title",
};

export const twoColumnForms: FormState[] = [
  FormState.leaveInfo,
  FormState.createAccount
];

export type IAdvIndustryRes = {
  industry_type: string;
  industry_list: {
    id: string;
    name: string;
    children?: IAdvIndustryResItem[];
  }[];
};

export type IAdvIndustryResItem = {
  id: string;
  key?: string;
  name: string;
  children?: IAdvIndustryResItem[];
};

export interface IAdvIndustry {
  id: string;
  key?: string;
  label: string;
  children?: IAdvIndustry[];
}

export type IAdvIndustryKey = string;

export const Level1IndustryOtherId = "9"; // 与后端的约定
export const IndustryOtherIdSet = [
  "291213",
  "291008",
  "292210",
  "291408",
  "291905",
  "291309",
  "290614",
  "291805",
  "292805"
];

// 留咨原因
// 【101注册地区】注册地区未开放自助
// 【102IP拦截】手选欧美与IP不一致
// 【103行业禁投】行业是禁投行业
// 【104没有税号】没有必填税号信息
// 【105注册上限】注册地区开放自助但达到当日注册门槛
export const LeaveInfoTipType = {
  NOT_OPEN: 101,
  IP_DIFF: 102,
  FORBIDDEN: 103,
  TAX_NOT_MATCH: 104,
  DAILYCAP: 105
};

export enum OauthType {
  NO_OAUTH = 'NO_OAUTH',
  TIKTOK_OAUTH_ONLY = 'TIKTOK_OAUTH_ONLY',
  TIKTOK_OAUTH_AND_EMAIL_PHONE = 'TIKTOK_OAUTH_AND_EMAIL_PHONE'
}

export enum AdvFormType {
  ORIGINAL = 'original',
  SIMPLIFY = 'simplify'
}

export type reportParamsType = {
  advertiser_id?: string
}

export type ReferralCodeInfo = {
  is_valid: boolean,
  contact: string
}
